export const TRAINING_FREQUENCIES = [
    {
        id: "days_2_3",
        labelKey: "planner.frequency.days23",
        descriptionKey: "planner.frequency.days23Desc",
        defaultSplit: "full_body",
        recommendedSplits: ["full_body", "top_bottom"],
    },
    {
        id: "days_3_4",
        labelKey: "planner.frequency.days34",
        descriptionKey: "planner.frequency.days34Desc",
        defaultSplit: "top_bottom",
        recommendedSplits: ["top_bottom", "push_pull", "full_body"],
    },
    {
        id: "days_4_5",
        labelKey: "planner.frequency.days45",
        descriptionKey: "planner.frequency.days45Desc",
        defaultSplit: "push_pull",
        recommendedSplits: ["push_pull", "top_bottom"],
    },
];

export const ROUTINE_SPLITS = [
    {
        id: "top_bottom",
        nameKey: "planner.splits.topBottom",
        descKey: "planner.splits.topBottomDesc",
        focuses: [
            { id: "top", nameKey: "planner.focuses.top", subtitleKey: "planner.focuses.topSub" },
            { id: "bottom", nameKey: "planner.focuses.bottom", subtitleKey: "planner.focuses.bottomSub" },
        ],
    },
    {
        id: "push_pull",
        nameKey: "planner.splits.pushPull",
        descKey: "planner.splits.pushPullDesc",
        focuses: [
            { id: "push", nameKey: "planner.focuses.push", subtitleKey: "planner.focuses.pushSub" },
            { id: "pull", nameKey: "planner.focuses.pull", subtitleKey: "planner.focuses.pullSub" },
        ],
    },
    {
        id: "full_body",
        nameKey: "planner.splits.fullBody",
        descKey: "planner.splits.fullBodyDesc",
        focuses: [
            { id: "full_body_a", nameKey: "planner.focuses.fullBodyA", subtitleKey: "planner.focuses.fullBodyASub" },
            { id: "full_body_b", nameKey: "planner.focuses.fullBodyB", subtitleKey: "planner.focuses.fullBodyBSub" },
        ],
    },
];

export const ROUTINE_PLANS = {
    full_body_a: [
        { slotId: "quad_dominant", defaultExerciseId: "leg_press", alternatives: ["squat", "front_squat"] },
        { slotId: "horizontal_push", defaultExerciseId: "bench_press", alternatives: ["incline_bench_press", "close_grip_bench_press"] },
        { slotId: "vertical_pull", defaultExerciseId: "lat_pulldown", alternatives: ["pull_up", "barbell_row"] },
        { slotId: "overhead_press", defaultExerciseId: "overhead_press", alternatives: ["push_press"] },
        { slotId: "core", defaultExerciseId: "plank", alternatives: ["dead_bug"] },
    ],
    full_body_b: [
        { slotId: "hip_hinge", defaultExerciseId: "romanian_deadlift", alternatives: ["deadlift"] },
        { slotId: "horizontal_pull", defaultExerciseId: "barbell_row", alternatives: ["lat_pulldown"] },
        { slotId: "incline_push", defaultExerciseId: "incline_bench_press", alternatives: ["bench_press"] },
        { slotId: "biceps", defaultExerciseId: "bicep_curl", alternatives: ["barbell_curl"] },
        { slotId: "triceps", defaultExerciseId: "tricep_pushdown", alternatives: ["close_grip_bench_press"] },
    ],
    top: [
        { slotId: "horizontal_push", defaultExerciseId: "bench_press", alternatives: ["incline_bench_press"] },
        { slotId: "vertical_pull", defaultExerciseId: "lat_pulldown", alternatives: ["pull_up"] },
        { slotId: "overhead_press", defaultExerciseId: "overhead_press", alternatives: ["push_press"] },
        { slotId: "horizontal_pull", defaultExerciseId: "barbell_row", alternatives: ["lat_pulldown"] },
        { slotId: "biceps", defaultExerciseId: "bicep_curl", alternatives: ["barbell_curl"] },
        { slotId: "triceps", defaultExerciseId: "tricep_pushdown", alternatives: ["close_grip_bench_press"] },
    ],
    bottom: [
        { slotId: "quad_dominant", defaultExerciseId: "leg_press", alternatives: ["squat", "front_squat"] },
        { slotId: "hip_hinge", defaultExerciseId: "romanian_deadlift", alternatives: ["deadlift"] },
        { slotId: "squat_compound", defaultExerciseId: "squat", alternatives: ["front_squat", "leg_press"] },
        { slotId: "core", defaultExerciseId: "plank", alternatives: ["dead_bug"] },
    ],
    push: [
        { slotId: "horizontal_push", defaultExerciseId: "bench_press", alternatives: ["incline_bench_press"] },
        { slotId: "incline_push", defaultExerciseId: "incline_bench_press", alternatives: ["bench_press"] },
        { slotId: "overhead_press", defaultExerciseId: "overhead_press", alternatives: ["push_press"] },
        { slotId: "triceps", defaultExerciseId: "tricep_pushdown", alternatives: ["close_grip_bench_press"] },
    ],
    pull: [
        { slotId: "vertical_pull", defaultExerciseId: "lat_pulldown", alternatives: ["pull_up"] },
        { slotId: "horizontal_pull", defaultExerciseId: "barbell_row", alternatives: ["lat_pulldown"] },
        { slotId: "hip_hinge", defaultExerciseId: "romanian_deadlift", alternatives: ["deadlift"] },
        { slotId: "biceps", defaultExerciseId: "bicep_curl", alternatives: ["barbell_curl"] },
    ],
};
